import * as types from '@/store/reports/actionTypes';
// eslint-disable-next-line import/no-cycle
import {
  loadHighlightReports,
  generateReport,
} from '@/services/repository';
import {
  SET_HIGHLIGHT_REPORTS_PAGINATION_STATE,
} from '@/store/pagination/mutationTypes';
import {
  SET_HIGHLIGHT_REPORTS_LOADING,
  SET_HIGHLIGHT_REPORTS, CLEAR_HIGHLIGHT_REPORTS, SET_HIGHLIGHT_REPORTS_LIST_OPTIONS,
  CLEAR_HIGHLIGHT_REPORTS_LIST_OPTIONS, SET_HIGHLIGHT_REPORTS_STATS, CLEAR_HIGHLIGHT_REPORTS_STATS,
} from '@/store/reports/mutationTypes';

export default {
  // eslint-disable-next-line no-unused-vars
  async [types.GENERATE_REPORT]({ commit }, payload) {
    // eslint-disable-next-line no-unused-vars
    const response = await generateReport(payload);
  },
  async [types.CLEAR_HIGHLIGHT_REPORTS_LIST_OPTIONS]({ commit }) {
    commit(CLEAR_HIGHLIGHT_REPORTS_LIST_OPTIONS);
  },
  async [types.CHANGE_HIGHLIGHT_REPORTS_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    let search = '';
    if (options.searchUpdated) {
      search = options.search;
    } else {
      search = options.search === undefined ? getters.highlightReportsListOptions.search : options.search;
    }
    commit(SET_HIGHLIGHT_REPORTS_LIST_OPTIONS, {
      sort: options.sort || getters.highlightReportsListOptions.sort,
      limit: options.limit || getters.highlightReportsListOptions.limit,
      page: options.page || getters.highlightReportsListOptions.page,
      search,
    });
    await dispatch(types.LOAD_HIGHLIGHT_REPORTS, {
      sort: options.sort,
      limit: options.limit,
      page: options.page,
      search: options.search,
      turnOnLoading: options.turnOnLoading,
      domain: options?.domain || getters.domainFilter,
      timeRange: options?.timeRange || getters.reportsDateFilter,
    });
  },
  async [types.LOAD_HIGHLIGHT_REPORTS]({ commit, getters }, payload) {
    try {
      if (payload.turnOnLoading) {
        commit(SET_HIGHLIGHT_REPORTS_LOADING, true);
      }

      const {
        items, stats, page, pageCount, count, total,
      } = await loadHighlightReports(
        {
          sort: payload.sort || getters.highlightReportsListOptions.sort,
          limit: payload.limit || getters.highlightReportsListOptions.limit,
          page: payload.page || getters.highlightReportsListOptions.page,
          search: payload.search === undefined ? getters.highlightReportsListOptions.search : payload.search,
          domain: payload?.domain || getters.domainFilter,
          timeRange: payload?.timeRange || getters.reportsDateFilter,
        },
      );
      commit(SET_HIGHLIGHT_REPORTS_PAGINATION_STATE, {
        page,
        pageCount,
        count,
        total,
      });
      commit(SET_HIGHLIGHT_REPORTS, items);
      commit(SET_HIGHLIGHT_REPORTS_STATS, stats);
    } catch (e) {
      commit(CLEAR_HIGHLIGHT_REPORTS);
      commit(CLEAR_HIGHLIGHT_REPORTS_STATS);
    } finally {
      commit(SET_HIGHLIGHT_REPORTS_LOADING, false);
    }
  },
};
